var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("page-header", {
        attrs: {
          page: _vm.page,
          "right-side-class":
            "align-items-end d-flex pb-2 justify-content-end col-4"
        },
        scopedSlots: _vm._u([
          {
            key: "customActions",
            fn: function() {
              return [
                _c(
                  "action-button",
                  {
                    staticClass: "mr-2",
                    attrs: {
                      i: "fas fa-arrow-circle-left",
                      variant: "outline-success"
                    },
                    on: { click: _vm.onGoBack }
                  },
                  [_vm._v(" Regresar ")]
                ),
                _vm.canSaveContract && _vm.canShowSaveButton
                  ? _c(
                      "action-button",
                      {
                        attrs: { i: "fas fas fa-save", variant: "success" },
                        on: { click: _vm.save }
                      },
                      [_vm._v(" Guardar ")]
                    )
                  : _vm._e(),
                _vm.visibleDropdownActions.length && !_vm.data.isDirectPayment
                  ? _c("dropdown", {
                      staticClass: "download-tariff-sheet-dropdown p-0",
                      attrs: {
                        items: _vm.dropdownActions,
                        responsive: "",
                        title: "Acciones"
                      }
                    })
                  : _vm._e()
              ]
            },
            proxy: true
          }
        ])
      }),
      _c("Provider-Header-Info", {
        attrs: {
          "can-edit-ssn": _vm.canEditSSNPermission,
          "company-id": parseInt(_vm.companyId)
        },
        on: {
          cancel: function($event) {
            return _vm.cancelEditProviderInfo()
          }
        },
        model: {
          value: _vm.data,
          callback: function($$v) {
            _vm.data = $$v
          },
          expression: "data"
        }
      }),
      _c(
        "div",
        { staticClass: "c-tabs" },
        [
          _c(
            "b-tabs",
            {
              attrs: {
                "active-nav-item-class":
                  "mipe-tab font-weight-bold text-mipe-orange mipe-active-tab",
                "active-tab-class": "",
                "content-class": "mt-3",
                "nav-class": "mipe-tab",
                "nav-wrapper-class": _vm.isViewingContract ? "d-none" : "",
                "no-nav-style": true
              },
              model: {
                value: _vm.tabIndex,
                callback: function($$v) {
                  _vm.tabIndex = $$v
                },
                expression: "tabIndex"
              }
            },
            [
              _c(
                "b-tab",
                {
                  attrs: { active: "", title: "Información del Proveedor" },
                  on: {
                    click: function($event) {
                      return _vm.$router.replace({ name: "provider-edit" })
                    }
                  }
                },
                [
                  _c("validation-observer", {
                    ref: "providerform",
                    attrs: { slim: "" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function({ handleSubmit }) {
                          return [
                            _c(
                              "b-form",
                              {
                                on: {
                                  submit: function($event) {
                                    $event.preventDefault()
                                    return handleSubmit(_vm.validateSsn)
                                  }
                                }
                              },
                              [
                                _c("provider-general-info-form", {
                                  model: {
                                    value: _vm.data,
                                    callback: function($$v) {
                                      _vm.data = $$v
                                    },
                                    expression: "data"
                                  }
                                }),
                                _c("b-row", [
                                  _c(
                                    "div",
                                    { staticClass: "mt-3 mb-1 col-12" },
                                    [
                                      _c("address-information-list", {
                                        attrs: {
                                          "add-enabled": _vm.userHasPermissions(
                                            "provider.address.add"
                                          ),
                                          "delete-enabled": _vm.userHasPermissions(
                                            "provider.address.delete"
                                          ),
                                          "edit-enabled": _vm.userHasPermissions(
                                            "provider.address.edit"
                                          ),
                                          "fiscal-year-id":
                                            _vm.value.fiscalYearId ||
                                            Number(_vm.fiscalYearId),
                                          "on-deleting": _vm.onAddressDeleting,
                                          "on-saving": _vm.onAddressSaving
                                        },
                                        model: {
                                          value: _vm.data.addresses,
                                          callback: function($$v) {
                                            _vm.$set(_vm.data, "addresses", $$v)
                                          },
                                          expression: "data.addresses"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ]),
                                _c("b-row", [
                                  _c(
                                    "div",
                                    { staticClass: "mt-3 mb-1 col-12" },
                                    [
                                      _c("contact-information-list", {
                                        attrs: {
                                          "add-enabled": _vm.userHasPermissions(
                                            "provider.contact.add"
                                          ),
                                          "civil-statuses": _vm.civilStatuses,
                                          "delete-enabled": _vm.userHasPermissions(
                                            "provider.contact.delete"
                                          ),
                                          "edit-enabled": _vm.userHasPermissions(
                                            "provider.contact.edit"
                                          ),
                                          "on-deleting": _vm.onContactDeleting,
                                          "on-saving": _vm.onContactSaving
                                        },
                                        model: {
                                          value: _vm.data.contacts,
                                          callback: function($$v) {
                                            _vm.$set(_vm.data, "contacts", $$v)
                                          },
                                          expression: "data.contacts"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ]),
                                _c("b-row", [
                                  _c(
                                    "div",
                                    { staticClass: "mt-3 mb-1 col-12" },
                                    [
                                      _c(
                                        "div",
                                        [
                                          _vm.companyId
                                            ? _c("section-title", {
                                                staticClass: "mt-4 mb-3",
                                                attrs: {
                                                  "has-line": "",
                                                  title:
                                                    "Documentos de Proveedor"
                                                }
                                              })
                                            : _vm._e(),
                                          (!_vm.data.documents ||
                                            _vm.data.documents.length === 0) &&
                                          !_vm.isAdding
                                            ? _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "bg-secondary-3 p-3 mt-3 rounded"
                                                },
                                                [
                                                  _c("div", [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "upload-file-button__container"
                                                      },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "panel-row-without-selector p-4"
                                                          },
                                                          [
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "col-12 text-center"
                                                              },
                                                              [
                                                                _c(
                                                                  "button",
                                                                  {
                                                                    staticClass:
                                                                      "btn bg-light-white col-12 col-md-4",
                                                                    on: {
                                                                      click: function(
                                                                        $event
                                                                      ) {
                                                                        _vm.isAdding = true
                                                                      }
                                                                    }
                                                                  },
                                                                  [
                                                                    _c("em", {
                                                                      staticClass:
                                                                        "fas fa-file-plus pr-4 text-green"
                                                                    }),
                                                                    _c(
                                                                      "span",
                                                                      {
                                                                        staticClass:
                                                                          "text-button-add-document"
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          " Presione aquí para anejar documento "
                                                                        )
                                                                      ]
                                                                    )
                                                                  ]
                                                                )
                                                              ]
                                                            )
                                                          ]
                                                        )
                                                      ]
                                                    )
                                                  ])
                                                ]
                                              )
                                            : _vm._e(),
                                          _vm.data.documents &&
                                          _vm.data.documents.length > 0
                                            ? _c(
                                                "div",
                                                _vm._l(
                                                  _vm.data.documents,
                                                  function(document) {
                                                    return _c(
                                                      "div",
                                                      {
                                                        key: document.id,
                                                        staticClass:
                                                          "bg-secondary-3 p-3 mt-3 rounded"
                                                      },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "row px-3"
                                                          },
                                                          [
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "col-12 col-md-4"
                                                              },
                                                              [
                                                                _c(
                                                                  "span",
                                                                  {
                                                                    staticClass:
                                                                      "font-weight-normal text-gray font-14"
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      " Tipo de Documento: "
                                                                    )
                                                                  ]
                                                                ),
                                                                _c(
                                                                  "p",
                                                                  {
                                                                    staticClass:
                                                                      "font-16"
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      " " +
                                                                        _vm._s(
                                                                          document.documentTypeName
                                                                        ) +
                                                                        " "
                                                                    )
                                                                  ]
                                                                )
                                                              ]
                                                            ),
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "col-12 col-md-7"
                                                              },
                                                              [
                                                                _c(
                                                                  "span",
                                                                  {
                                                                    staticClass:
                                                                      "font-weight-normal text-gray font-14"
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      " Nombre de Documento: "
                                                                    )
                                                                  ]
                                                                ),
                                                                _c(
                                                                  "p",
                                                                  {
                                                                    staticClass:
                                                                      "font-16"
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        document.fileName
                                                                      )
                                                                    )
                                                                  ]
                                                                )
                                                              ]
                                                            ),
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "col-12 col-md-1 text-right"
                                                              },
                                                              [
                                                                _c(
                                                                  "action-button",
                                                                  {
                                                                    staticClass:
                                                                      "mr-2 mt-2",
                                                                    attrs: {
                                                                      i:
                                                                        "fas fa-file-download",
                                                                      variant:
                                                                        "success"
                                                                    },
                                                                    on: {
                                                                      click: () =>
                                                                        _vm.onDownload(
                                                                          document.documentId
                                                                        )
                                                                    }
                                                                  }
                                                                ),
                                                                _c(
                                                                  "action-button",
                                                                  {
                                                                    staticClass:
                                                                      "mr-2 mt-2",
                                                                    attrs: {
                                                                      i:
                                                                        "fas fa-times-circle",
                                                                      variant:
                                                                        "danger"
                                                                    },
                                                                    on: {
                                                                      click: () =>
                                                                        _vm.onRemoveDocuments(
                                                                          document.documentId
                                                                        )
                                                                    }
                                                                  }
                                                                )
                                                              ],
                                                              1
                                                            )
                                                          ]
                                                        )
                                                      ]
                                                    )
                                                  }
                                                ),
                                                0
                                              )
                                            : _vm._e(),
                                          _vm.data.documents.length > 0 &&
                                          !_vm.isAdding
                                            ? _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "d-flex justify-content-end mt-3"
                                                },
                                                [
                                                  _c(
                                                    "action-button",
                                                    {
                                                      attrs: {
                                                        i: "fas fa-file-plus",
                                                        variant: "success"
                                                      },
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          _vm.isAdding = true
                                                        }
                                                      }
                                                    },
                                                    [_vm._v(" Añadir ")]
                                                  )
                                                ],
                                                1
                                              )
                                            : _vm._e(),
                                          _vm.isAdding
                                            ? _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "bg-secondary-3 p-3 mt-3 rounded"
                                                },
                                                [
                                                  _c(
                                                    "validation-observer",
                                                    {
                                                      ref: "documentObserver",
                                                      staticClass: "row mx-2",
                                                      attrs: { tag: "div" }
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "col-md-4 col-sm-6"
                                                        },
                                                        [
                                                          _c(
                                                            "validation-provider",
                                                            {
                                                              attrs: {
                                                                rules:
                                                                  "required"
                                                              },
                                                              scopedSlots: _vm._u(
                                                                [
                                                                  {
                                                                    key:
                                                                      "default",
                                                                    fn: function({
                                                                      errors
                                                                    }) {
                                                                      return [
                                                                        _c(
                                                                          "custom-drop-down",
                                                                          {
                                                                            attrs: {
                                                                              id:
                                                                                "ddlDocumentType",
                                                                              "custom-error-msg":
                                                                                "Favor seleccionar tipo de documento.",
                                                                              error:
                                                                                errors[0],
                                                                              fieldkey:
                                                                                "id",
                                                                              fieldname:
                                                                                "name",
                                                                              label:
                                                                                "Tipo de Documento",
                                                                              options:
                                                                                _vm.filteredDocumentTypes
                                                                            },
                                                                            model: {
                                                                              value:
                                                                                _vm
                                                                                  .model
                                                                                  .documentType,
                                                                              callback: function(
                                                                                $$v
                                                                              ) {
                                                                                _vm.$set(
                                                                                  _vm.model,
                                                                                  "documentType",
                                                                                  $$v
                                                                                )
                                                                              },
                                                                              expression:
                                                                                "model.documentType"
                                                                            }
                                                                          }
                                                                        )
                                                                      ]
                                                                    }
                                                                  }
                                                                ],
                                                                null,
                                                                true
                                                              )
                                                            }
                                                          )
                                                        ],
                                                        1
                                                      ),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "col-md-4 col-sm-6",
                                                          class:
                                                            _vm.model.file &&
                                                            "d-flex justify-content-center"
                                                        },
                                                        [
                                                          _c(
                                                            "validation-provider",
                                                            {
                                                              attrs: {
                                                                rules:
                                                                  "required"
                                                              },
                                                              scopedSlots: _vm._u(
                                                                [
                                                                  {
                                                                    key:
                                                                      "default",
                                                                    fn: function({
                                                                      errors
                                                                    }) {
                                                                      return [
                                                                        _c(
                                                                          "custom-file-input",
                                                                          {
                                                                            ref:
                                                                              "fileUpload",
                                                                            staticClass:
                                                                              "mt-4 pt-1",
                                                                            attrs: {
                                                                              accept:
                                                                                "pdf",
                                                                              "custom-error-msg":
                                                                                "Favor seleccionar un documento.",
                                                                              "display-style":
                                                                                "normal",
                                                                              error:
                                                                                errors[0],
                                                                              label:
                                                                                "",
                                                                              "label-position":
                                                                                "left",
                                                                              "on-download": () => {},
                                                                              required:
                                                                                ""
                                                                            },
                                                                            model: {
                                                                              value:
                                                                                _vm
                                                                                  .model
                                                                                  .file,
                                                                              callback: function(
                                                                                $$v
                                                                              ) {
                                                                                _vm.$set(
                                                                                  _vm.model,
                                                                                  "file",
                                                                                  $$v
                                                                                )
                                                                              },
                                                                              expression:
                                                                                "model.file"
                                                                            }
                                                                          }
                                                                        )
                                                                      ]
                                                                    }
                                                                  }
                                                                ],
                                                                null,
                                                                true
                                                              )
                                                            }
                                                          )
                                                        ],
                                                        1
                                                      ),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "col-md-4"
                                                        },
                                                        [
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "mt-4 text-right"
                                                            },
                                                            [
                                                              _c(
                                                                "action-button",
                                                                {
                                                                  attrs: {
                                                                    id:
                                                                      "btnCancel",
                                                                    i:
                                                                      "fas fa-times-circle",
                                                                    variant:
                                                                      "outline-danger btn-cancel danger m-2"
                                                                  },
                                                                  on: {
                                                                    click:
                                                                      _vm.closeAdding
                                                                  }
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    " Cancelar "
                                                                  )
                                                                ]
                                                              ),
                                                              _c(
                                                                "action-button",
                                                                {
                                                                  attrs: {
                                                                    id:
                                                                      "btnAdd",
                                                                    i:
                                                                      "fas fa-file-plus",
                                                                    variant:
                                                                      "success pl-4 pr-4"
                                                                  },
                                                                  on: {
                                                                    click:
                                                                      _vm.onAdd
                                                                  }
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    " Añadir "
                                                                  )
                                                                ]
                                                              )
                                                            ],
                                                            1
                                                          )
                                                        ]
                                                      )
                                                    ]
                                                  )
                                                ],
                                                1
                                              )
                                            : _vm._e()
                                        ],
                                        1
                                      )
                                    ]
                                  )
                                ])
                              ],
                              1
                            )
                          ]
                        }
                      }
                    ])
                  })
                ],
                1
              ),
              _vm.showContractTab
                ? _c(
                    "b-tab",
                    {
                      attrs: {
                        active: _vm.canActiveContractView,
                        title: "Contrato"
                      },
                      on: {
                        click: function($event) {
                          return _vm.$router.replace({
                            name: "resultContracts"
                          })
                        }
                      }
                    },
                    [
                      _c("contract-provider", {
                        ref: "contratProviderRef",
                        attrs: { data: _vm.data },
                        on: { "on-change-model": _vm.onChangeModelHandler }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.isMedicaidDocumentationWorkflowEnabled
                ? _c(
                    "b-tab",
                    {
                      attrs: {
                        active: _vm.canActiveMedicaidEligibilityView,
                        title: "Elegibilidad de Medicaid"
                      },
                      on: {
                        click: function($event) {
                          return _vm.$router.replace({
                            name: "medicaid-eligibility"
                          })
                        }
                      }
                    },
                    [
                      _c("medicaid-eligibility", {
                        attrs: {
                          "medical-identifier": _vm.data.medicalIdentifier,
                          "provider-id": parseInt(_vm.companyId)
                        },
                        on: {
                          "update:medicalIdentifier": function($event) {
                            return _vm.$set(
                              _vm.data,
                              "medicalIdentifier",
                              $event
                            )
                          },
                          "update:medical-identifier": function($event) {
                            return _vm.$set(
                              _vm.data,
                              "medicalIdentifier",
                              $event
                            )
                          }
                        },
                        model: {
                          value: _vm.data.nationalIdentifier,
                          callback: function($$v) {
                            _vm.$set(_vm.data, "nationalIdentifier", $$v)
                          },
                          expression: "data.nationalIdentifier"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }